module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serial-form"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Tryout Serial',
          to: {
            path: '/serial'
          },
          exact: true
        },
        {
          text: 'Tambah Tryout Serial'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(_vm.id == null ? "Tambah" : "Ubah") + " Tryout Serial\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Judul *\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Judul Tryout Serial",
      "outlined": ""
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Deskripsi\n                ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Deskripsi Tryout Serial",
      "outlined": ""
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Kelas\n                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "placeholder": "Pilih Kelas",
      "items": [{
          text: '1 (SD)',
          value: 1
        },
        {
          text: '2 (SD)',
          value: 2
        },
        {
          text: '3 (SD)',
          value: 3
        },
        {
          text: '4 (SD)',
          value: 4
        },
        {
          text: '5 (SD)',
          value: 5
        },
        {
          text: '6 (SD)',
          value: 6
        },
        {
          text: '7 (SMP)',
          value: 7
        },
        {
          text: '8 (SMP)',
          value: 8
        },
        {
          text: '9 (SMP)',
          value: 9
        },
        {
          text: '10 (SMA)',
          value: 10
        },
        {
          text: '11 (SMA)',
          value: 11
        },
        {
          text: '12 (SMA)',
          value: 12
        } ]
    },
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  })], 1)], 1), _vm._v(" "), (_vm.id != null) ? _c('v-card', {
    staticClass: "px-0 pt-0 mt-3 ma-0 pb-8",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 text-subtitle-1 font-weight-bold"
  }, [_vm._v("\n                Serial\n            ")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('v-card', {
      key: group.series_sequence,
      staticClass: "my-3",
      attrs: {
        "outlined": ""
      }
    }, [_c('v-list', {
      staticClass: "pa-0 text-subtitle-2"
    }, [
      [_c('v-list-item', {
        attrs: {
          "two-line": ""
        }
      }, [_c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start",
        staticStyle: {
          "max-width": "10%"
        }
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                    Group ID\n                                ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticStyle: {
          "text-overflow": "unset",
          "white-space": "unset"
        }
      }, [_vm._v("\n                                    " + _vm._s(group.id) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "mx-2 my-0 align-self-start"
      }, [_c('v-list-item-subtitle', {
        staticClass: "font-weight-bold"
      }, [_vm._v("\n                                    Tryout Group\n                                ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                                    " + _vm._s(group.name) + "\n                                ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
        staticClass: "pa-0",
        attrs: {
          "plain": ""
        },
        on: {
          "click": function($event) {
            return _vm.confirmUnAttachGroup(group)
          }
        }
      }, [_c('span', {
        staticClass: "red--text",
        class: _vm.$vuetify.breakpoint.mdAndUp ?
          'font-weight-700' :
          'font-weight-600',
        style: (_vm.$vuetify.breakpoint.smAndDown ?
          'font-size: 12px' :
          '')
      }, [_vm._v("Hapus")])])], 1)], 1)]
    ], 2)], 1)
  }), _vm._v(" "), _c('app-tryoutgroupchooser', {
    attrs: {
      "params": {
        grade: _vm.grade,
        attached: false
      }
    },
    on: {
      "dblClicked": function($event) {
        return _vm.onGroupSelected($event)
      }
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v(" Simpan ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.showUnAttachModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.showUnAttachModal),
      callback: function($$v) {
        _vm.showUnAttachModal = $$v
      },
      expression: "showUnAttachModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                Hapus Tryout Group\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Apakah anda yakin akan menghapus Tryout Group\n                "), _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.selectedGroup.name))]), _vm._v("\n                pada Serial\n                "), _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" ?\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUnAttachModal = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.processUnAttachGroup()
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-172b6d74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/serial/components/Form.vue
// module id = 2072
// module chunks = 1